/* src/modules/locations/cards/AddLocationCard/reducers.js */

import {
  LOCATION_NAME_CHANGED,
  LOCATION_ADDRESS_CHANGED,
  LOCATION_CITY_CHANGED,
  LOCATION_TYPE_CHANGED,
  LOCATION_LONGITUDE_CHANGED,
  LOCATION_LATITUDE_CHANGED,
  CLEAR_LOCATION_FIELDS,
} from './action_types';

const INITIAL_STATE = {
  name: '',
  address: '',
  city: '',
  type: '',
  longitude: '',
  latitude: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOCATION_NAME_CHANGED:
      return { ...state, name: action.payload };
    case LOCATION_ADDRESS_CHANGED:
      return { ...state, address: action.payload };
    case LOCATION_CITY_CHANGED:
      return { ...state, city: action.payload };
    case LOCATION_TYPE_CHANGED:
      return { ...state, type: action.payload };
    case LOCATION_LONGITUDE_CHANGED:
      return { ...state, longitude: action.payload };
    case LOCATION_LATITUDE_CHANGED:
      return { ...state, latitude: action.payload };
    case CLEAR_LOCATION_FIELDS:
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/locations/cards/AddLocationCard/reducers.js